import { Injectable, HostListener } from '@angular/core';
import { BehaviorSubject, Observable, Subscriber } from 'rxjs';

// Menu
export interface Menu {
	path?: string;
	title?: string;
	icon?: string;
	type?: string;
	badgeType?: string;
	badgeValue?: string;
	active?: boolean;
	bookmark?: boolean;
	children?: Menu[];
}

@Injectable({
	providedIn: 'root'
})

export class NavService {

	public screenWidth: any
	public collapseSidebar: boolean = false
	public fullScreen = false;

	constructor() {
		this.onResize();
		if (this.screenWidth < 991) {
			this.collapseSidebar = true
		}
	}

	// Windows width
	@HostListener('window:resize', ['$event'])
	onResize(event?:any) {
		this.screenWidth = window.innerWidth;
	}

	MENUITEMS: Menu[] = [
		{
			title: "Entidades",
			icon: "home",
			type: "sub",
			active: true,
			children: [
			  { path: "/empresa/listar-empresa", title: "Listado de entidades", type: "link" },
			  { path: "/empresa-dato-contacto/listar-empresa-dato-contacto", title: "Listado de contactos", type: "link" },
			  { path: "/empresa/crear-empresa", title: "Crear entidad", type: "link" },
			  { path: "/empresa-dato-contacto/crear-empresa-dato-contacto", title: "Crear contacto", type: "link" }
			],
		},
		{
			title: "Convenio",
			icon: "home",
			type: "sub",
			active: false,
			children: [
			  { path: "/convenio/listar-convenio", title: "Listado de convenios", type: "link" },
			  { path: "/convenio-contacto/listar-convenio-contacto", title: "Listado de contactos", type: "link" }, 
			  { path: "/convenio/crear-convenio", title: "Crear convenio", type: "link" },
			  { path: "/convenio-contacto/crear-convenio-contacto", title: "Crear contacto", type: "link" }
			],
		},
		{
			title: "Plazas y cupos",
			icon: "home",
			type: "sub",
			active: false,
			children: [
			  { path: "/convenio-plaza/listar-convenio-plaza", title: "Listado de plazas", type: "link" },
			  { path: "/convenio-plaza/crear-convenio-plaza", title: "Crear plaza", type: "link" },
			  { path: "/convenio-plaza/mapa-convenio-plaza", title: "Ubicar plaza", type: "link" }
			],
		},
		{
			title: "Reservas",
			icon: "users",
			type: "sub",
			active: false,
			children: [
			  { path: "/convenio-plaza-reserva/listar", title: "Listado de reservas", type: "link" },
			  { path: "/operacion/listar", title: "Listado de operaciones", type: "link" },
			  { path: "/reportes", title: "Reportes", type: "link" },
			],
		},
		{
		   title: "Seguridad",
		   icon: "users",
		   type: "sub",
		   active: false,
		   children: [
			   { path: "/seguridad/usuario-listar", title: "Listar usuarios", type: "link" }
		   ]
		}
		
		/*,
		{
			title: "Sample Page",
			icon: "home",
			type: "sub",
			active: false,
			children: [
			  { path: "/sample-page/sample-page1", title: "sample-page-1", type: "link" },
			  { path: "/sample-page/sample-page2", title: "sample-page-2", type: "link" },
			],
		 },
		 { path: "/sample-page3", icon: "home", title: "sample-page-3", type: "link" },
		 */
		 
	]
	// Array
	items = new BehaviorSubject<Menu[]>(this.MENUITEMS);


}
